import React, { useContext, useEffect, useImperativeHandle, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    cardsTypeAtom,
    cardsTypeConst,
    clickHideAtom,
    panoramaCardsTypeAtom,
    rodinCardsTypeAtom,
    showCardsConAtom,
    userPermissionAtom,
    haveSearchTabAtom
} from '../../../store';
import style from './menu.module.css';
import { useTranslation } from "react-i18next";
import { PermissionContext } from "../../../utils/context";
import { trackEvent } from '../../../utils/trackEvent'
import { isPrerenderUserAgent } from '../../../utils/hooks';

const Menu = React.forwardRef((props, ref) => {
    const { menuType } = props;
    const [rouletteOutHover, setRouletteOutHover] = useState(false);
    const [rodinCardsType, setRodinCardsType] = useRecoilState(rodinCardsTypeAtom);
    const setPanoramaCardsType = useSetRecoilState(panoramaCardsTypeAtom);
    const [cardsType, setCardsType] = useRecoilState(cardsTypeAtom);
    const [showCardsCon, setShowCardsCon] = useRecoilState(showCardsConAtom);
    const clickHide = useRecoilValue(clickHideAtom);
    const [userPermission] = useRecoilState(userPermissionAtom);
    const { t } = useTranslation();
    const hasSeenStoryTip = localStorage.getItem('hasSeenStoryTip2');
    const [storyTipVisible, setStoryTipVisible] = useState(false);

    useEffect(() => {

        if (!hasSeenStoryTip) {
            setStoryTipVisible(true);
            const timer = setTimeout(() => {
                setStoryTipVisible(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, []);
    useImperativeHandle(ref, () => ({
        toggleCardType: toggleCardType
    }))

    useEffect(() => {
        return () => {
            const canonicalLink = document.querySelector('link[rel="canonical"][href*="/rodin/tab/Story"]');
            if (canonicalLink) {
                canonicalLink.remove();
            }
        };
    }, []);

    const toggleCardType = (item) => {
        trackEvent(`Menu - ${item}: Switch`, { menu:item })
        if (item === 'Story') {
            setStoryTipVisible(false);
            localStorage.setItem('hasSeenStoryTip2', 'true');
        }
        // if (item === 'Story') {
        //     // FIX： Keep SEO but don't change the address bar
        //     if (!document.querySelector('link[rel="canonical"][href*="/rodin/tab/Story"]')) {
        //         const link = document.createElement('link');
        //         link.rel = 'canonical';
        //         link.href = `${window.location.origin}/rodin/tab/Story`;
        //         document.head.appendChild(link);
        //     }
        // } else {
        //     history.pushState(null, '', location);
        // }
        setCardsType(item);
        _czc.push(['_trackEvent', 'Index', `${item} Tab`, 'Gallery Component']);
        _czc.push(['_trackPageview', `/rodin/tab/${item.toLocaleLowerCase()}`, window.location.href]);
    }

    const { isAllowedTo } = useContext(PermissionContext);

    const LangChatAvatarMenuList = [
        { name: t('CHATAVATAR_GALLERY_HEAD_MENU_TIPS_1'), permission: userPermission.chatavatar_tab_group, params: 'Group' },
        { name: t('CHATAVATAR_GALLERY_HEAD_MENU_TIPS_2'), permission: userPermission.chatavatar_menu_Mine, params: 'Mine' },
        { name: t('CHATAVATAR_GALLERY_HEAD_MENU_TIPS_3'), permission: true, params: 'Featured' },
        { name: t('CHATAVATAR_GALLERY_HEAD_MENU_TIPS_4'), permission: userPermission.chatavatar_menu_Recent, params: 'Recent' }
    ]

    const LangRodinMenuList = [
        { name: t('RODIN_GALLERY_HEAD_MENU_TIPS_1'), permission: isAllowedTo('featured.nav.gallery.rodin.view'), params: 'Featured' },
        { name: t('RODIN_GALLERY_HEAD_MENU_TIPS_2'), permission: isAllowedTo('mine.nav.gallery.rodin.view') && userPermission.chatavatar_menu_Mine, params: 'Mine' },
        { name: t('RODIN_GALLERY_HEAD_MENU_TIPS_3'), permission: isAllowedTo('story.nav.gallery.rodin.view'), params: 'Story' },
        { name: t('RODIN_GALLERY_HEAD_MENU_TIPS_4'), permission: isAllowedTo('recent.nav.gallery.rodin.view') && userPermission.chatavatar_menu_Recent, params: 'Recent' },
    ]

    const ChatAvatarBasicMenu = () => {
        return LangChatAvatarMenuList.map((item) => (
            item.permission && <div
                key={item.name}
                onClick={toggleCardType.bind(null, item.params)}
                className={`${style.menu} ${cardsType === cardsTypeConst[item.params] ? style.selected : ''}`}
            >
                {item.name}
            </div>
        ))
    }

    const RodinBasicMenu = () => {
        return ['Sketchfab', 'Free3D', 'BlendSwap'].map((item, index) => (
            <div
                key={index}
                onPointerDown={() => {
                    setRodinCardsType(item);
                }}
                className={`${style.menu} ${rodinCardsType === item ? style.selected : ''}`}>
                {item}
            </div>
        ))
    }

    const PanoramBasicMenu = () => {
        return <div className={style.panoramaWrapper}>
            <div
                className={`${style.RouletteOut} ${rouletteOutHover ? style.menuShow : ''}`}
                onMouseEnter={() => setRouletteOutHover(true)}
                onMouseLeave={() => setRouletteOutHover(false)}
            >
                <div
                    style={{
                        backgroundColor: rouletteOutHover ? '#ccc6c6' : 'rgba(255,255,255,0.6)',
                    }}
                    className={`${style.RouletteIn} ${rouletteOutHover ? style.menuShow : ''}`}
                />
                {rouletteOutHover
                    && (
                        <div className={style.circleContainer}>
                            {['Mine', 'Featured', 'Recent'].map((item, index) => (
                                <div
                                    key={index}
                                    className={style.sectorBox}
                                    onClick={() => {
                                        setPanoramaCardsType(item);
                                        setShowCardsCon(true);
                                    }}
                                >
                                    <span
                                        style={index === 1 ? {
                                            bottom: '60%',
                                            left: '10%',
                                        } : {
                                            left: '20%',
                                            top: '30%',
                                        }}
                                    >{item}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
            </div>
        </div>
    }

    const NewRodinMene = () => {
        return (
            <div className='flex justify-between items-center w-full'>
                <div className='flex gap-3 sm:gap-4 md:gap-5 my-4'>
                    {isPrerenderUserAgent() && <a href='/rodin/tab/story' title='Story' />}
                    {LangRodinMenuList.map((item, index) => {
                        return (
                            item.permission && (
                                <div className="relative" key={index}>
                                    <div
                                        className={`flex-center w-[max-content] rounded-2xl px-3 py-1 sm:px-4 sm:py-2 md:px-5 md:py-[10px] [border:1px_solid_rgba(255,255,255,0.2)] text-screen-sm inline-block transition-300-ease cursor-pointer ${cardsType === item.params ? "text-[#FFFFFF] bg-[#6F6CFF] border-[#6F6CFF]" : "text-[rgba(200, 200, 200, 1)] hover:text-white bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)]"}`}
                                        onClick={toggleCardType.bind(null, item.params)}
                                    >
                                        <span className="relative">
                                            {item.name}
                                            {item.params === 'Story' && !hasSeenStoryTip && (
                                                <span className="absolute -top-1 -right-2 w-2 h-2 bg-red-500 rounded-full"></span>
                                            )}
                                        </span>
                                    </div>

                                    {item.params === 'Story' && storyTipVisible && (
                                        <div
                                            className={`absolute left-0 -top-16 bg-[rgba(255,255,255,0.08)] backdrop-blur-[68px]  p-3 rounded-[16px] shadow-lg whitespace-nowrap cursor-pointer ${style.storyTip}`}
                                        >
                                            <span className='[background-image:linear-gradient(90deg,#E9B664_44.89%,#8C76F0_92.99%)] [color:transparent] [-webkit-background-clip:text]'>Share Stories, Earn Credits - Try Our New Feature!</span> 🥳💰
                                            <div className={style.tipArrow}></div>
                                        </div>
                                    )}
                                </div>
                            )
                        )
                    })}
                </div>
            </div>
        )
    }

    const MenuComponent = {
        'chatAvatar': <div className={style.menuCon}>
            <ChatAvatarBasicMenu />
        </div>,

        "Rodin": <div className={`${style.menuCon} ${style.rodinMenu}`}>
            <RodinBasicMenu />
        </div>,

        "panorama": <div className={`${style.menuCon} ${showCardsCon ? style.hideMenuCon : ''} ${clickHide ? style.conHide : ''}`}>
            <PanoramBasicMenu />
        </div>,
        "newRodin": <NewRodinMene />
    }

    return MenuComponent[menuType]
})


Menu.displayName = 'Menu';
export { Menu };
